import { Stack, Tab, Tabs } from "@mui/material";
import { t } from "i18next";
import PropTypes from "prop-types";

function TabBar({ value, handleChange }) {
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
      sx={{ width: "100%" }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
        TabIndicatorProps={{
          style: {
            backgroundColor: "black",
          },
        }}
        sx={{
          ".MuiTab-root": {
            color: "#A6A9AC",
          },
          ".Mui-selected": {
            color: "black !important",
          },
        }}
      >
        <Tab value="worker" label={t("worker")} wrapped />
        <Tab value="company" label={t("company")} />
        <Tab value="supplier" label={t("supplier")} />
        {/* <Tab value="education" label={t("education")} /> */}
      </Tabs>
    </Stack>
  );
}

TabBar.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default TabBar;
